/* eslint-disable no-constant-condition */
import { useState, useEffect } from "react";
import { Grid, Switch, FormControlLabel } from "@mui/material";
import InputGroup from "../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import TextAreaGroup from "../../../components/FormComponent/TextAreaGroup";
import { httprequest } from "../../../data/api";
import Button from "../../../components/Button";
import { toast } from "react-toastify";
import useValidator from "../../../hooks/useValidator";
import Layout from "../../../components/Layout";
import BreadCrumb from "../../../components/BreadCrumb";
import useStyles from "../styles";
import { useNavigate } from "react-router-dom";
import { useUserState } from "../../../context/UserContext";
import WidgetTitle from "../../dashboard/components/WidgetTitle/WidgetTitle";
// import { ContinousAssessment } from "../../../utils/DropDown";
import useWindowSize from "../../../hooks/useWindow";

const TEACHER_CLASS_ENDPOINT = "/api/v1/teacher/classes";
// const TEACHER_SUBJECT_ENDPOINT = "/api/v1/teacher/subjects";
const ADMIN_CLASS_ENDPOINT = "/api/v1/class";
// const ADMIN_SUBJECT_ENDPOINT = "/api/v1/subjects";
const TEST_CONFIG_ENDPOINT = "/api/v1/test-configs";
const CLASS_SUBJECT = "/api/v1/class-subject/";
const TEACHER_SUBJECT = "/api/v1/teacher/class-subject/";
const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const SESSION_ENDPOINT = "/api/v1/school-plan/session";
const OBTAINABLE_SCORE = "/api/v1/obtainable-score";

const CreateCA = () => {
  // const [file, setFile] = useState();
  const navigate = useNavigate();
  const styles = useStyles();
  const { userRole } = useUserState();
  const [classData, setClassData] = useState([]);
  // const [subjectData, setSubjectData] = useState([]);
  const [obtainablescore, setObtainableScore] = useState([]);
  const [isCreating, setIsCreating] = useState(false);
  const [allClassSubject, setAllClassSubject] = useState([]);
  const [aselectedTerm, setASelectedTerm] = useState("");
  const [testValidator, showTestValidator] = useValidator();
  // const [selectedClassSubjects, setSelectedClassSubjects] = useState([]);
  // const [activeTerm, setActiveTerm] = useState([]);
  const [allTerm, setAllTerms] = useState([]);
  const [sessionData, setSessionData] = useState([]);
  const [activeSession, setActiveSession] = useState([]);
  const width = useWindowSize();
  const isSmallScreen = width < 700;
  const isTeacher = userRole?.role_type === "employee";

  const [testForm, setTestFrom] = useState({
    subject_id: "",
    term_id: "",
    title: "",
    class_id: "",
    submission_date: "",
    description: "",
    total_grade: 0,
    instruction: "",
    publish_date: "",
    duration: "",
    test_date: "",
    random_question: "no",
    randomize_options: "no",
    display_score_after_exam: "no",
    question_display_mode: "",
    proctoring_requirements: "",
    browser_lockdown: false,
    is_private: false,
    questions: []
  });

  /**
 * Fetches all available academic sessions from the backend.
 * Updates the sessionData state with the fetched data.
 */
  const getAllSession = () => {
    httprequest
      .get(SESSION_ENDPOINT)
      .then((res) => {
        setSessionData(res?.data?.data);
        setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
      })
      .catch(() => {});
  };

  /**
   * Fetches all obtainable scores from the API
   */
  const getAllObtainableScores = () => {
    httprequest
      .get(OBTAINABLE_SCORE)
      .then((res) => {
        setObtainableScore(res?.data?.data?.find((obtainable) => obtainable?.session?.id === activeSession?.id) || []);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  /**
 * Fetches all terms from the backend and filters by session ID.
 * @param {string} Session_id - The ID of the selected session.
 */
  const getAllTerms = (Session_id) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        setAllTerms(res?.data?.data.filter((session_term) => session_term?.session_id === Session_id));
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  /**
   * Get the active term in a session
   */
  const active_term_session = activeSession?.terms?.find((found_active_term) => found_active_term?.is_current === true);

  /**
   *
   * @param {event parameter passed on handleChange} event
   * Handles the change event when a new term is selected
   */
  const handleTermChange = (event) => {
    const selectedTermId = event.target.value;

    setASelectedTerm(selectedTermId);
    setTestFrom({ ...testForm, term_id: selectedTermId });
  };

  /**
   * Handle Session Change
   * @param {event parameter passed on handleSessionChange} e
   */
  const handleSessionChange = (e) => {
    const Session_ID = e.target.value;
    // setTestFrom({ ...testForm, [name]: value });
    getAllTerms(Session_ID);
  };

  /**
 * Handles change to test input fields (e.g., title, instruction).
 * @param {event parameter passed on handleTestChange} e
 */
  const handleTestChange = (e) => {
    const { name, value, type, checked } = e.target;
    const next = { ...testForm, [name]: type === "checkbox" ? checked : value };
    setTestFrom(next);
  };

  /**
 * This handles the Subject Test input
 * @param {React.ChangeEvent<HTMLInputElement>} e
 */
  const handleSubjectTestChange = (e) => {
    const { value } = e.target;

    setTestFrom({ ...testForm, subject_id: value });
  };

  /**
   * Builds the create test config payload to match the API shape.
   */
  const buildTestConfigPayload = (status = "published") => {
    const durationNum = Number(testForm.duration);
    const testDate = testForm.test_date ? new Date(testForm.test_date).toISOString() : null;

    return {
      class_id: testForm.class_id || null,
      subject_id: testForm.subject_id || null,
      term_id: testForm.term_id || null,
      ca_type: testForm.ca_type || null,
      title: (testForm.title || "").trim() || null,
      duration: Number.isNaN(durationNum) ? 0 : durationNum,
      test_date: testDate,
      instructions: (testForm.instruction || "").trim() || "",
      randomize_questions: testForm.random_question === "yes",
      randomize_options: testForm.randomize_options === "yes",
      display_score_after_test_date: testForm.display_score_after_exam === "yes",
      is_private: !!testForm.is_private,
      questions_display_mode: testForm.question_display_mode === "one" ? "one_per_page" : "all_at_once",
      questions: [],
      status
    };
  };

  /**
 * creates test config with status "published" (no questions yet).
 */
  const handleCreateTest = () => {
    if (testValidator.allValid()) {
      setIsCreating(true);
      const payload = buildTestConfigPayload("published");
      httprequest
        .post(TEST_CONFIG_ENDPOINT, payload)
        .then((res) => {
          setIsCreating(false);
          toast.success(res?.data?.message);
          const newId = res?.data?.data?.id;
          if (newId) {
            navigate(`/assessment-detail/${newId}`);
          } else {
            setTimeout(() => navigate("/assessment"), 1500);
          }
        })
        .catch((err) => {
          setIsCreating(false);
          toast.error(err?.response?.data?.message);
        });
    } else {
      showTestValidator(true);
    }
  };

  /**
 * Fetches all classes for the current user depending on their role (teacher or admin),
 * and updates the `classData` state with the result.
 */
  const fetchClasses = () => {
    const ENDPOINT = isTeacher ? TEACHER_CLASS_ENDPOINT : ADMIN_CLASS_ENDPOINT;

    httprequest
      .get(ENDPOINT)
      .then((res) => {
        setClassData(res?.data?.data);
      })
      .catch(() => {
      });
  };

  /**
 * Fetches all subjects for a selected class, depending on the user role (teacher or admin),
 * and updates the `allClassSubject` state with the result.
 *
 * @param {string} classValue - The ID or value of the selected class.
 */
  const getAllSubjectForClass = async (classValue) => {
    const ENDPOINT = isTeacher ? TEACHER_SUBJECT : CLASS_SUBJECT;
    httprequest
      .get(`${ENDPOINT}${classValue}`)
      .then((res) => {
        setAllClassSubject(res?.data?.data);
      })
      .catch(() => {
      });
  };

  /**
 * Handles a change in the selected class input,
 * updates the test form state and fetches subjects for the selected class.
 *
 * @param {event parameter passed on handleClassChange} e - The change event from the class select input.
 */
  const handleClassChange = (e) => {
    const { name, value } = e.target;
    setTestFrom({ ...testForm, [name]: value });
    getAllSubjectForClass(value);
  };

  useEffect(() => {
    fetchClasses();
    getAllSession();
    // getAllAdminSubjects();
  }, []);

  /**
 * On detection of active term, set selected term and set the term_id in the test form.
 */
  useEffect(() => {
    if (active_term_session?.id) {
      setASelectedTerm(active_term_session.id);
      setTestFrom({ ...testForm, term_id: active_term_session?.id });
    }
  }, [active_term_session]);

  /**
 * When the active session changes, fetch the terms for that session.
 */
  useEffect(() => {
    if (activeSession?.id) {
      // setSelectedSession(activeSession?.id);
      getAllTerms(activeSession?.id);
      getAllObtainableScores();
    }
  }, [activeSession]);

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            {isTeacher ? (
              <div>
                <BreadCrumb
                  link_one="/assessment"
                  link_one_name="All CA Test"
                  active="Create CA Test"
                  description="Create a new Test"
                />
              </div>
            ) : (
              <div>
                <BreadCrumb
                  link_one="/assessment"
                  link_one_name="CA Test"
                  active="Create CA Test"
                  description="Create CA Test questions"
                />
              </div>
            )}
            <div className="flex gap-10">
              <Button
                variant="primary"
                buttonSize="fluid"
                color="btndefault"
                buttonName="Create Test"
                isLoading={isCreating}
                onClick={handleCreateTest}
              />
            </div>
          </div>
          <div className="page-content">
            <div className={styles.assignmentcontainerform}>
              <WidgetTitle
                title="Test Metadata"
                // subtitle="View Metrics for all student attendance in your school"
              />
              <div className={styles.assignmentsection}>
                <Grid container spacing={2}>
                  {/* Row 1: 6-3-3 */}
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Test Title"
                      margin="normal"
                      inputType="text"
                      inputName="title"
                      value={testForm.title}
                      onChange={handleTestChange}
                      required
                    />
                    {testValidator.message(
                      "title",
                      testForm?.title,
                      "required"
                    )}
                  </Grid>
                  <Grid item lg={3} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="CA Type"
                      required
                      children={
                        <select
                          name="ca_type"
                          onChange={handleTestChange}
                        >
                          <option value="">---Select---</option>
                          {obtainablescore?.ca?.map((ca, index) => {
                            return (
                              <option key={index} value={ca?.ca_type}>
                                {ca?.ca_type}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                  </Grid>
                  {isTeacher ? (
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                      <SelectGroup
                        label="Select Class"
                        required
                        children={
                          <select
                            name="class_id"
                            onChange={handleClassChange}
                          >
                            <option value="">--- Select ---</option>
                            {classData?.map((clss) => {
                              return (
                                <option key={clss?.class?.id} value={clss?.class?.id}>
                                  {clss?.class?.name}
                                </option>
                              );
                            })}
                          </select>
                        }
                      />
                      {testValidator.message(
                        "class_id",
                        testForm?.class_id,
                        "required"
                      )}
                    </Grid>
                  ) : (
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                      <SelectGroup
                        label="Select Class"
                        required
                        children={
                          <select
                            name="class_id"
                            onChange={handleClassChange}
                          >
                            <option value="">--- Select ---</option>
                            {classData?.map((clss) => {
                              return (
                                <option key={clss?.id} value={clss?.id}>
                                  {clss?.class_name}
                                </option>
                              );
                            })}
                          </select>
                        }
                      />
                      {testValidator.message(
                        "class_id",
                        testForm?.class_id,
                        "required"
                      )}
                    </Grid>
                  )}
                  {/* Row 2: 4-4-4 */}
                  {isTeacher ? (
                    <Grid item lg={4} md={6} sm={6} xs={12}>
                      <SelectGroup
                        label="Select Subject"
                        required
                        children={
                          <select
                            name="subject_id"
                            onChange={handleSubjectTestChange}
                          >
                            <option value="">--- Select ---</option>
                            {allClassSubject?.map((sub) => {
                              return (
                                <option key={sub?.subject.id} value={sub?.subject.id}>
                                  {sub?.subject?.name}
                                </option>
                              );
                            })}
                          </select>
                        }
                      />
                      {testValidator.message(
                        "subject_id",
                        testForm?.subject_id,
                        "required"
                      )}
                    </Grid>
                  ) : (
                    <Grid item lg={4} md={6} sm={6} xs={12}>
                      <SelectGroup
                        label="Select Subject"
                        required
                        children={
                          <select
                            name="subject_id"
                            onChange={handleSubjectTestChange}
                          >
                            <option value="">--- Select ---</option>
                            {allClassSubject?.map((sub) => {
                              return (
                                <option key={sub?.subject_id} value={sub?.subject_id}>
                                  {sub?.subject_name}
                                </option>
                              );
                            })}
                          </select>
                        }
                      />
                      {testValidator.message(
                        "subject_id",
                        testForm?.subject_id,
                        "required"
                      )}
                    </Grid>
                  )}
                  <Grid item lg={4} md={6} sm={12} xs={12}>
                    {activeSession?.id && (
                      <SelectGroup
                        label="Session"
                        required
                        children={
                          <select
                            defaultValue={activeSession?.id}
                            onChange={handleSessionChange}
                            name="session"
                          >
                            <option value="">---Select---</option>
                            {sessionData?.map((sesh) => {
                              return (
                                <option key={sesh?.id} value={sesh?.id}>
                                  {sesh?.session}
                                </option>
                              );
                            })}
                          </select>
                        }
                      />
                    )}
                  </Grid>
                  <Grid item lg={4} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Select Term"
                      required
                      children={
                        <select
                          name="term_id"
                          value={aselectedTerm}
                          onChange={handleTermChange}
                        >
                          <option value="">--- Select ---</option>
                          {allTerm?.map((term) => {
                            return (
                              <option key={term?.id} value={term?.id}>
                                {term?.term}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                    {testValidator.message(
                      "Term Id",
                      testForm?.term_id,
                      "required"
                    )}
                  </Grid>
                  {/* Test Instruction and Description: full width */}
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className={styles.inputmargin}>
                      <TextAreaGroup
                        label="Test Instruction"
                        inputName="instruction"
                        margin="normal"
                        placeholder=""
                        value={testForm.instruction}
                        onChange={handleTestChange}
                      />
                    </div>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className={styles.inputmargin}>
                      <TextAreaGroup
                        label="Description"
                        inputName="description"
                        margin="normal"
                        placeholder=""
                        value={testForm.description}
                        onChange={handleTestChange}
                      />
                    </div>
                  </Grid>
                  {/* <Grid item lg={4} md={6} sm={12} xs={12}>
                    <Tooltip title="If selected, assignment will be created; otherwise, saved as a draft">
                      <label className={styles.enterque}>Published Date<span className="input-required"> *</span></label>
                    </Tooltip>
                    <InputGroup
                      margin="normal"
                      inputType="date"
                      inputName="publish_date"
                      inputMin={new Date().toISOString().split("T")[0]}
                      onChange={handleTestChange}
                    />
                    {testValidator.message(
                      "Publish Date",
                      testForm?.publish_date,
                      "required"
                    )}
                  </Grid> */}
                </Grid>
              </div>
              <WidgetTitle title="Time Configuration" />
              <div className={styles.assignmentsection}>
                <Grid container spacing={2}>
                  <Grid item lg={3} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Test Duration (minutes)"
                      margin="normal"
                      inputType="number"
                      inputName="duration"
                      placeHolder="e.g. 60"
                      value={testForm.duration}
                      onChange={handleTestChange}
                      required
                    />
                    {testValidator.message(
                      "duration",
                      testForm?.duration,
                      "required"
                    )}
                  </Grid>
                  <Grid item lg={3} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Test Date"
                      margin="normal"
                      inputType="datetime-local"
                      inputName="test_date"
                      value={typeof testForm.test_date === "string" && testForm.test_date.length >= 16 ? testForm.test_date.slice(0, 16) : (testForm.test_date ? new Date(testForm.test_date).toISOString().slice(0, 16) : "")}
                      inputMin={new Date().toISOString().split("T")[0]}
                      onChange={handleTestChange}
                      required
                    />
                    {testValidator.message(
                      "Test Date",
                      testForm?.test_date,
                      "required"
                    )}
                  </Grid>
                </Grid>
              </div>
              <WidgetTitle title="Behavior Settings" />
              <div className={styles.assignmentsection}>
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Random Question"
                      children={
                        <select
                          name="random_question"
                          value={testForm.random_question}
                          onChange={handleTestChange}
                        >
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Randomize options"
                      children={
                        <select
                          name="randomize_options"
                          value={testForm.randomize_options}
                          onChange={handleTestChange}
                        >
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Display Score after Test"
                      children={
                        <select
                          name="display_score_after_exam"
                          value={testForm.display_score_after_exam}
                          onChange={handleTestChange}
                        >
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Question Display Mode"
                      children={
                        <select
                          name="question_display_mode"
                          value={testForm.question_display_mode}
                          onChange={handleTestChange}
                        >
                          <option value="">--- Select ---</option>
                          <option value="all">All at once</option>
                          <option value="one">One per page</option>
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <label className={styles.enterque}>
                      <input
                        className="margin-top-5"
                        type="checkbox"
                        name="is_private"
                        checked={!!testForm.is_private}
                        onChange={handleTestChange}
                      />
                      {" "}Visibility (Private)
                    </label>
                  </Grid>
                </Grid>
              </div>
              <WidgetTitle title="Security Settings" />
              <div className={styles.assignmentsection}>
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Proctoring requirements"
                      children={
                        <select
                          name="proctoring_requirements"
                          value={testForm.proctoring_requirements}
                          onChange={handleTestChange}
                        >
                          <option value="">--- Select ---</option>
                          <option value="none">None</option>
                          <option value="basic">Basic</option>
                          <option value="strict">Strict</option>
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 16 }}>
                      <FormControlLabel
                        control={
                          <Switch
                            name="browser_lockdown"
                            checked={!!testForm.browser_lockdown}
                            onChange={(e) => handleTestChange({ target: { name: "browser_lockdown", value: e.target.checked } })}
                            color="primary"
                          />
                        }
                        label="Browser Lockdown"
                      />
                    </div>
                  </Grid>
                </Grid>
              </div>
              <div className={styles.btnwrapper}>
                <Button
                  variant="primary"
                  color="btndefault"
                  buttonSize={isSmallScreen ? "full" : "fluid"}
                  buttonName="Create Test"
                  onClick={handleCreateTest}
                  isLoading={isCreating}
                />
              </div>
            </div>
          </div>
          {/* <ToastContainer /> */}
        </>
      }
    />
  );
};

export default CreateCA;
